module.exports = __webpack_public_path__ + "static/media/ClinicaBazterrica.f179f559.svg";